export default __webpack_public_path__ + "static/cafeterabg1_4-de733c6d5b50f171e831ccb6d6eb01e3.png";